"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apply = function (fn, input, probability) {
    if (probability === void 0) { probability = 0.0; }
    return Math.random() > 1.0 - probability ? fn(input) : input;
};
